import plusIcon from "../assets/svg/plus-table.svg";
import factor from "../assets/svg/factorDefault.svg";
import factorHover from "../assets/svg/factorDefaultHover.svg";
import factorDefaultActive from "../assets/svg/factorDefaultActive.svg";
import financialTransactions from "../assets/svg/financialTransactions.svg";
import financialTransactionsHover from "../assets/svg/financialTransactionsHover.svg";
import financialTransactionsActive from "../assets/svg/financialTransactionsActive.svg";
import warehouseRemittance from "../assets/svg/warehouseRemittance.svg";
import warehouseRemittanceHover from "../assets/svg/warehouseRemittanceHover.svg";
import warehouseRemittanceActive from "../assets/svg/warehouseRemittanceActive.svg";
import { apiDeleteFactors, apiGetFactors, apiGetFactorsExcel, apiSetFactorApproved } from "../api/factorApi";
import { updateFactor } from "../store/actions/formAction";
import { apiPersonsList } from "../api/personApi";
import { apiGetProjects } from "../api/projectApi";
import { apiGetBranches } from "../api/branchApi";
import { openFactorDrawer } from "helpers/DrawerActions";
import { formatPrice } from "../helpers";
import StatusComponent from "components/Table/StatusComponent";
import { Approvement } from "components/Table/CellComponents";
import getCurrency from "helpers/currencyHelper";
import { Props } from "components/Table/StatusComponent"

export const searchType = {
  default: "default", //default view
  quantitative: "quantitative", // When a value that contains numbers
  date: "date", // When use date picker in view
  autocomplete: "autocomplete", // when you need search item has autocomplete
  status: "status", // when search view show status or tag  item
};

const defaultTableColumns = [
  {
    name: "بررسی فاکتور",
    key: "approved",
    filterParams: {
      column: "approved",
      columnType: "string",
    },
    searchType: "status",
    dataKey: [
      { label: "تایید شده", value: 1, id: 1 },
      { label: "تایید نشده", value: 0, id: 2 },
    ],
    reqUrl: apiSetFactorApproved,
    Component: Approvement,
  },
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    searchType: searchType.default,
  },
  {
    name: "عنوان",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string",
    },
    clickable: (item) => true,
    onClick: (dispatch, item) => {
      openFactorDrawer(dispatch, item);
    },
    searchType: searchType.default,
  },
  {
    name: "مشتری",
    key: "Person",
    searchKey: "nickName",
    getValue: (item) => {
      return item.Person?.nickName ?? "-";
    },
    filterParams: {
      column: "PersonId",
      columnType: "string",
      relationModelName: "Person",
      relationColumn: "nickName",
    },
    navigateKey: (item) => item.PersonId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: searchType.autocomplete,
    dataKey: {
      column: "persons",
      key: "nickName",
    },
  },
  {
    name: "شماره موبایل",
    key: "personMobile",
    filterParams: {
      subColumn: "personMobile",
      // column: "totalPrice",
      columnType: "string",
    },
    getValue: (item) => item.personMobile || ""

  },
  {
    name: "فروشنده",
    key: "Seller",
    searchKey: "firstName",
    getValue: (item) => {
      return item.Seller?.nickName ?? "-";
    },
    filterParams: {
      column: "SellerId",
      columnType: "string",
      relationModelName: "Person",
      relationColumn: "nickName",
    },
    navigateKey: (item) => item.SellerId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: searchType.autocomplete,
    dataKey: {
      column: "persons",
      key: "nickName",
    },
  },
  {
    name: "پروژه",
    key: "Project",
    searchKey: "title",
    getValue: (item) => {
      return item.Project?.title ?? "-";
    },
    filterParams: {
      column: "ProjectId",
      columnType: "string",
      relationModelName: "Project",
      relationColumn: "title",
    },
    searchType: searchType.autocomplete,
    dataKey: {
      column: "projects",
      key: "title",
    },
  },
  {
    name: "شعبه",
    key: "Branch",
    searchKey: "title",
    getValue: (item) => {
      return item.Branch?.title ?? "-";
    },
    filterParams: {
      column: "BranchId",
      columnType: "string",
      relationModelName: "Branch",
      relationColumn: "title",
    },
    searchType: "autocomplete",
    dataKey: {
      column: "branches",
      key: "title",
    },
  },
  {
    name: "مبلغ",
    key: "totalPrice",
    filterParams: {
      subColumn: "totalPrice",
      // column: "totalPrice",
      columnType: "number",
    },
    getValue: (item) =>
      `${formatPrice(item?.totalPrice || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
    searchType: searchType.quantitative,
  },
  {
    name: "تاریخ ثبت",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "تاریخ سر رسید",
    key: "dueDate",
    filterParams: {
      column: "dueDate",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "ارجاع",
    key: "reference",
    filterParams: {
      column: "reference",
      columnType: "string",
    },
    searchType: searchType.default,
  },
  {
    name: "وضعیت",
    key: "status",
    filterParams: {
      column: "status",
      columnType: "string",
    },
    searchType: searchType.status,
    Component: StatusComponent,
    getValue: (item) => {
      return item?.status;
    },
    dataKey: [
      { label: "تایید شده", value: "تایید شده", id: 1 },
      { label: "دریافت شده", value: "دریافت شده", id: 2 },
      { label: "پرداخت شده", value: "پرداخت شده", id: 3 },
      { label: "مرجوع شده", value: "مرجوع شده", id: 4 },
    ],
  },
];

const estimateTableColumns = [
  {
    name: "بررسی فاکتور",
    key: "approved",
    filterParams: {
      column: "approved",
      columnType: "string",
    },
    searchType: "status",
    dataKey: [
      { label: "تایید شده", value: 1, id: 1 },
      { label: "تایید نشده", value: 0, id: 2 },
    ],
    reqUrl: apiSetFactorApproved,
    Component: Approvement,
  },
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    searchType: searchType.default,
  },
  {
    name: "عنوان",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string",
    },
    clickable: (item) => true,
    onClick: (dispatch, item) => {
      openFactorDrawer(dispatch, item);
    },
    searchType: searchType.default,
  },
  {
    name: "مشتری",
    key: "Person",
    searchKey: "nickName",
    getValue: (item) => {
      return item.Person?.nickName ?? "-";
    },
    filterParams: {
      column: "PersonId",
      columnType: "string",
      relationModelName: "Person",
      relationColumn: "nickName",
    },
    navigateKey: (item) => item.PersonId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: searchType.autocomplete,
    dataKey: {
      column: "persons",
      key: "nickName",
    },
  },
  {
    name: "فروشنده",
    key: "Seller",
    searchKey: "firstName",
    getValue: (item) => {
      return item.Seller?.nickName ?? "-";
    },
    filterParams: {
      column: "SellerId",
      columnType: "string",
      relationModelName: "Person",
      relationColumn: "nickName",
    },
    navigateKey: (item) => item.SellerId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: searchType.autocomplete,
    dataKey: {
      column: "persons",
      key: "nickName",
    },
  },
  {
    name: "پروژه",
    key: "Project",
    searchKey: "title",
    getValue: (item) => {
      return item.Project?.title ?? "-";
    },
    filterParams: {
      column: "ProjectId",
      columnType: "string",
      relationModelName: "Project",
      relationColumn: "title",
    },
    searchType: searchType.autocomplete,
    dataKey: {
      column: "projects",
      key: "title",
    },
  },
  {
    name: "شعبه",
    key: "Branch",
    searchKey: "title",
    getValue: (item) => {
      return item.Branch?.title ?? "-";
    },
    filterParams: {
      column: "BranchId",
      columnType: "string",
      relationModelName: "Branch",
      relationColumn: "title",
    },
    searchType: "autocomplete",
    dataKey: {
      column: "branches",
      key: "title",
    },
  },
  {
    name: "شماره موبایل",
    key: "personMobile",
    filterParams: {
      subColumn: "personMobile",
      // column: "totalPrice",
      columnType: "string",
    },
    getValue: (item) => item.personMobile || ""

  },
  {
    name: "مبلغ",
    key: "totalPrice",
    filterParams: {
      subColumn: "totalPrice",
      // column: "totalPrice",
      columnType: "number",
    },
    getValue: (item) =>
      `${formatPrice(item?.totalPrice || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
    searchType: searchType.quantitative,
  },
  {
    name: "تاریخ ثبت",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "تاریخ سر رسید",
    key: "dueDate",
    filterParams: {
      column: "dueDate",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "ارجاع",
    key: "reference",
    filterParams: {
      column: "reference",
      columnType: "string",
    },
    searchType: searchType.default,
  },
  {
    name: "نوع پیش فاکتور",
    key: "status",
    filterParams: {
      column: "type",
      columnType: "string",
    },
    searchType: searchType.status,
    Component: StatusComponent,
    getValue: (item) => {
      switch (item?.type) {
        case "sale":
          return "فروش";
        case "buy":
          return "خرید";
        case "saleReturn":
          return "برگشت از فروش";
        case "buyReturn":
          return "برگشت از خرید";
        case "waste":
          return "ضایعات";
      }
    },
    dataKey: [
      { label: "فروش", value: "sale", id: 1 },
      { label: "خرید", value: "buy", id: 2 },
      { label: "برگشت از فروش", value: "saleReturn", id: 3 },
      { label: "برگشت از خرید", value: "buyReturn", id: 4 },
      { label: "ضایعات", value: "waste", id: 5 },
      // { label: "پیش نویس", value: "پیش نویس", id: 3 },
    ],
  },
];

const allTableColumns = [
  {
    name: "بررسی فاکتور",
    key: "approved",
    filterParams: {
      column: "approved",
      columnType: "string",
    },
    searchType: "status",
    dataKey: [
      { label: "تایید شده", value: 1, id: 1 },
      { label: "تایید نشده", value: 0, id: 2 },
    ],
    reqUrl: apiSetFactorApproved,
    Component: Approvement,
  },
  {
    name: "کد حسابداری",
    key: "accountingCode",
    filterParams: {
      column: "accountingCode",
      columnType: "string",
    },
    searchType: searchType.default,
  },
  {
    name: "عنوان",
    key: "title",
    filterParams: {
      column: "title",
      columnType: "string",
    },
    clickable: (item) => true,
    onClick: (dispatch, item) => {
      openFactorDrawer(dispatch, item);
    },
    searchType: searchType.default,
  },
  {
    name: "مشتری",
    key: "Person",
    searchKey: "nickName",
    getValue: (item) => {
      return item.Person?.nickName ?? "-";
    },
    filterParams: {
      column: "PersonId",
      columnType: "string",
      relationModelName: "Person",
      relationColumn: "nickName",
    },
    navigateKey: (item) => item.PersonId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: searchType.autocomplete,
    dataKey: {
      column: "persons",
      key: "nickName",
    },
  },
  {
    name: "فروشنده",
    key: "Seller",
    searchKey: "firstName",
    getValue: (item) => {
      return item.Seller?.nickName ?? "-";
    },
    filterParams: {
      column: "SellerId",
      columnType: "string",
      relationModelName: "Person",
      relationColumn: "nickName",
    },
    navigateKey: (item) => item.SellerId,
    navigate: "/reports/personalAccountCard?personId=",
    searchType: searchType.autocomplete,
    dataKey: {
      column: "persons",
      key: "nickName",
    },
  },
  {
    name: "پروژه",
    key: "Project",
    searchKey: "title",
    getValue: (item) => {
      return item.Project?.title ?? "-";
    },
    filterParams: {
      column: "ProjectId",
      columnType: "string",
      relationModelName: "Project",
      relationColumn: "title",
    },
    searchType: searchType.autocomplete,
    dataKey: {
      column: "projects",
      key: "title",
    },
  },
  {
    name: "شعبه",
    key: "Branch",
    searchKey: "title",
    getValue: (item) => {
      return item.Branch?.title ?? "-";
    },
    filterParams: {
      column: "BranchId",
      columnType: "string",
      relationModelName: "Branch",
      relationColumn: "title",
    },
    searchType: "autocomplete",
    dataKey: {
      column: "branches",
      key: "title",
    },
  },
  {
    name: "شماره موبایل",
    key: "personMobile",
    filterParams: {
      subColumn: "personMobile",
      // column: "totalPrice",
      columnType: "string",
    },
    getValue: (item) => item.personMobile || ""

  },
  {
    name: "مبلغ",
    key: "totalPrice",
    filterParams: {
      subColumn: "totalPrice",
      // column: "totalPrice",
      columnType: "number",
    },
    getValue: (item) =>
      `${formatPrice(item?.totalPrice || 0)} ${item?.Currency?.en_title || getCurrency().defCur.en_title}`,
    searchType: searchType.quantitative,
  },
  {
    name: "تاریخ ثبت",
    key: "date",
    filterParams: {
      column: "date",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "تاریخ سر رسید",
    key: "dueDate",
    filterParams: {
      column: "dueDate",
      columnType: "date",
    },
    searchType: searchType.date,
  },
  {
    name: "ارجاع",
    key: "reference",
    filterParams: {
      column: "reference",
      columnType: "string",
    },
    searchType: searchType.default,
  },
  {
    name: "نوع فاکتور",
    key: "type",
    filterParams: {
      column: "type",
      columnType: "string",
    },
    searchType: searchType.status,
    Component: StatusComponent,
    getValue: (item) => {
      switch (item?.type) {
        case "sale":
          return "فروش";
        case "buy":
          return "خرید";
        case "saleReturn":
          return "برگشت از فروش";
        case "buyReturn":
          return "برگشت از خرید";
        case "waste":
          return "ضایعات";
      }
    },
    dataKey: [
      { label: "فروش", value: "sale", id: 1 },
      { label: "خرید", value: "buy", id: 2 },
      { label: "برگشت از فروش", value: "saleReturn", id: 3 },
      { label: "برگشت از خرید", value: "buyReturn", id: 4 },
      { label: "ضایعات", value: "waste", id: 5 },
      // { label: "پیش نویس", value: "پیش نویس", id: 3 },
    ],
  },
  {
    name: "وضعیت",
    key: "status",
    filterParams: {
      column: "status",
      columnType: "string",
    },
    searchType: searchType.status,
    Component: StatusComponent,
    getValue: (item) => {
      return item?.status;
    },
    dataKey: [
      { label: "تایید شده", value: "تایید شده", id: 1 },
      { label: "دریافت شده", value: "دریافت شده", id: 2 },
      { label: "پرداخت شده", value: "پرداخت شده", id: 3 },
      { label: "مرجوع شده", value: "مرجوع شده", id: 4 },
    ],
  },
];

export const factorIndexData = [
  {
    title: "همه",
    description: "",
    key: "allFactors",
    label: "همه",
    pluralLabel: "همه فاکتور ها",
    pageTitle: "همه فاکتور ها",
    pageDescription: "لیست فاکتورهای کسب و کار",
    tableColumns: allTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      edit: {},
      print: {},
      printExitFromInventory: {},
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "فروش",
    description: "",
    key: "sale",
    label: "فروش",
    pluralLabel: "فروش ها",
    pageTitle: "فاکتورهای فروش",
    pageDescription: "لیست فاکتورهای فروش کسب و کار",
    tableColumns: [...defaultTableColumns, {
      name: "نوع صورت حساب",
      key: "taxType",
      filterParams: {
        column: "taxType",
        columnType: "string",
      },
      searchType: searchType.status,
      getValue: (item) => {
        return item?.taxType == 2 ? 'نوع دوم' : item?.taxType == 1 ? 'نوع اول' : "نوع دوم";
      },
      dataKey: [
        { label: "نوع اول", value: "1", id: 1 },
        { label: "نوع دوم", value: "2", id: 2 },

      ],
    },
    {
      name: "نوع تسویه",
      key: "taxSettlementType",
      filterParams: {
        column: "taxSettlementType",
        columnType: "string",
      },
      searchType: searchType.status,
      getValue: (item) => {
        return item?.taxSettlementType == "Cash" ? 'نقدی' : item?.taxSettlementType == "Credit" ? 'نسیه' : item?.taxSettlementType == "CashCredit" ? "نقدی/نسیه" : "نقدی";
      },
      dataKey: [
        { label: "نقدی", value: "Cash", id: 1 },
        { label: "نسیه", value: "Credit", id: 2 },
        { label: "نقدی/نسیه", value: "CashCredit", id: 3 },

      ],
    }
    ],
    disableDateFilter: true,
    actions: {
      printExitFromInventory: {},
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      invoice: {},
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "خرید",
    description: "",
    key: "buy",
    label: "خرید",
    pluralLabel: "خریدها",
    pageTitle: "فاکتورهای خرید",
    pageDescription: "لیست فاکتورهای خرید کسب و کار",
    tableColumns: defaultTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      labelPrint: true,
      getProducts: (item) => {
        let arr = [];
        if (!item?.Factor_Items) return arr
        for (const i of item?.Factor_Items) {
          const count = i.quantity;
          if (!count) return;
          for (let j = 0; j < count; j++) {
            arr.push(i.Product);
          }
        }
        return arr;
      },
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "پیش فاکتور",
    description: "",
    key: "estimate",
    label: "پیش فاکتور",
    pluralLabel: "پیش فاکتورها",
    pageTitle: "پیش فاکتورها",
    pageDescription: "لیست پیش فاکتورهای کسب و کار",
    tableColumns: estimateTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "برگشت از فروش",
    description: "",
    key: "saleReturn",
    label: "برگشت از فروش",
    pluralLabel: "برگشت از فروش ها",
    pageTitle: "فاکتورهای برگشت از فروش",
    pageDescription: "لیست فاکتورهای برگشت از فروش کسب و کار",
    tableColumns: defaultTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "برگشت از خرید",
    description: "",
    key: "buyReturn",
    label: "برگشت از خرید",
    pluralLabel: "برگشت از خریدها",
    pageTitle: "فاکتورهای برگشت از خرید",
    pageDescription: "لیست فاکتورهای برگشت از خرید کسب و کار",
    tableColumns: defaultTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "ضایعات",
    description: "",
    key: "waste",
    label: "ضایعات",
    pluralLabel: "ضایعات",
    pageTitle: "فاکتورهای ضایعات",
    pageDescription: "لیست فاکتورهای ضایعات کسب و کار",
    tableColumns: defaultTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  },
  {
    title: "بدون حواله",
    description: "",
    key: "withoutBill",
    label: "بدون حواله",
    pluralLabel: "بدون حواله",
    pageTitle: "فاکتورهای بدون حواله",
    pageDescription: "لیست فاکتورهای بدون حواله کسب و کار",
    tableColumns: defaultTableColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "ثبت فاکتور",
        icon: plusIcon,
        url: "/factors/add",
      },
      edit: {},
      fetch: apiGetFactors,
      delete: apiDeleteFactors,
      copy: true,
      view: {
        url: "/factors/view",
        id: "factorId",
        label: "مشاهده فاکتور",
        // openDrawer: openFactorDrawer,
      },
      excel: {
        export: apiGetFactorsExcel,
      },
      print: {},
      labelPrint: true,
      getProducts: (item) => {
        let arr = [];
        if (!item?.Factor_Items) return arr
        for (const i of item.Factor_Items) {
          const count = i.quantity;
          if (!count) return;
          for (let j = 0; j < count; j++) {
            arr.push(i.Product);
          }
        }
        return arr;
      },
      sort: {
        model: "Factor",
      },
      archive: {
        model: 'factor'
      }
    },
  }
];

export const factorHeaderData = {
  title: "ثبت فاکتور",
  backTitle: "لیست فاکتور کالا/خدمات",
  backUrl: "/factors",
  breadCrumb: [
    // {
    //     key: "dashboard",
    //     title: null,
    //     imgDefault: IconDashboard,
    //     imgHover: IconDashboardHoverBreadcrumb,
    //     imgActive: IconActiveDashboardHoverBreadcrumb,
    // },
    {
      key: "factor",
      title: "فاکتور کالا/خدمات",
      imgDefault: factor,
      imgHover: factorHover,
      imgActive: factorDefaultActive,
    },
    {
      key: "financial",
      title: "تراکنش مالی",
      imgDefault: financialTransactions,
      imgHover: financialTransactionsHover,
      imgActive: financialTransactionsActive,
    },
    {
      key: "remittance",
      title: "حواله انبار",
      imgDefault: warehouseRemittance,
      imgHover: warehouseRemittanceHover,
      imgActive: warehouseRemittanceActive,
    },
  ],
};

export const factorFormData = {
  factor: {
    title: "فاکتور",
    tabs: [
      {
        name: "فروش",
        key: "sale",
        form: {
          discountOption: true,
          discountInput: {
            formType: "factor",
            name: "discount",
            label: "تخفیف",
            isPercentage: true,
          },
          taxOption: true,
          taxInput: {
            formType: "factor",
            name: "tax",
            label: "مالیات",
            isPercentage: true,
            defaultValue: 0,
          },
          transportOption: true,
          transportInput: {
            formType: "factor",
            name: "transport",
            label: "حمل و نقل",
            isPercentage: false,
          },
          draftOption: true,
          draftInput: {
            formType: "factor",
            outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
            name: "isDraft",
            label: "پیش فاکتور",
          },
          returnOption: true,
          returnInput: {
            formType: "factor",
            outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
            name: "isReturnedFactor",
            label: "فاکتور مرجوعی",
          },
          customCostsInput: {
            formType: "factor",
            name: "additionalCosts",
          },
          header: [
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
              active: true,
              type: "accountingCode",
              name: "accountingCode",
              label: "کد حسابداری",
              maxLength: 20,
              options: [
                {
                  label: "اتوماتیک",
                  value: true,
                },
                {
                  label: "دستی",
                  value: false,
                },
              ],
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "person",
                  title: "افزودن شخص",
                  closeButton: true,
                  onFinish: (token) => apiPersonsList(token, "customer"),
                },
              },
              name: "person",
              label: "مشتری",
              showInput: true,
              required: true,
              options: "customers",
              onChange: (dispatch, value) => {
                const title = value ? `فاکتور فروش ${value.nickName}` : null;
                dispatch(updateFactor("title", title));
              },
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-6 col-sm-12 col-xs-12 style-padding-inputs",
              name: "title",
              label: "عنوان",
              maxLength: 64,
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              name: "reference",
              label: "ارجاع",
              maxLength: 64,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "datePickerInput",
              name: "storeDate",
              label: "تاریخ",
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "datePickerInput",
              name: "paymentDate",
              label: "تاریخ سررسید",
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "branch",
                  title: "افزودن شعبه",
                  closeButton: true,
                  onFinish: (token) => apiGetBranches(token),
                },
              },
              name: "branch",
              label: "شعبه",
              showInput: true,
              options: "branches",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-6 col-sm-12 col-xs-12 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "project",
                  title: "افزودن پروژه",
                  closeButton: true,
                  onFinish: (token) => apiGetProjects(token),
                },
              },
              name: "project",
              label: "پروژه",
              showInput: true,
              options: "projects",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-6 col-sm-12 col-xs-12 style-padding-inputs",
              type: "selectBox",
              name: "seller",
              label: "مسئول فروش",
              showInput: true,
              options: "customers",
              onChange: (dispatch, value) => {
                const commission = value?.Person_Settings?.find((ps) => ps.key === "saleCommission");
                if (commission) {
                  dispatch(updateFactor("sellerCommission", parseInt(commission.value)));
                }
              },
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-6 col-sm-12 col-xs-12 style-padding-inputs",
              name: "sellerCommission",
              type: "percent",
              label: "درصد",
              disabled: false,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "currency",
              name: "factor",
              label: "واحد پول",
              maxLength: 16,
              showInput: false,
            },
          ],
          body: [
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 style-fields-right',
            //     type: 'selectBox',
            //     name: 'productCategory',
            //     label: 'دسته بندی',
            //     showInput: true,
            //     options: 'productCategories'
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-3 col-md-3 col-sm-3 col-xs-6',
            //     type: 'selectBox',
            //     name: 'product',
            //     label: 'کالا / خدمات',
            //     showInput: true,
            //     options: 'products'
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-6",
            //     type: "empty"
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 ps-5',
            //     type: 'currency',
            //     name: 'product',
            //     label: 'واحد پول',
            //     maxLength: 16,
            //     showInput: false,
            // },
            {
              formType: "factor",
              factorType: "sell",
              outerWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
              type: "factorTable",
              name: "items",
              inputs: [
                { key: "product", title: "محصول", size: "20", type: "select" },
                { key: "description", title: "شرح", size: "10", type: "text" },
                { key: "unit", title: "واحد", size: "10", type: "unit" },
                { key: "quantity", title: "تعداد", size: "10", type: "price" },
                { key: "price", title: "قیمت واحد", size: "10", type: "price" },
                {
                  key: "discount",
                  title: "تخفیف",
                  size: "10",
                  type: "discount",
                },
                { key: "tax", title: "مالیات", size: "10", type: "percent" },
                {
                  key: "totalPrice",
                  title: "قیمت کل",
                  size: "10",
                  type: "price",
                  disabled: true,
                },
              ],
            },
          ],
        },
      },
      {
        name: "خرید",
        key: "buy",
        form: {
          discountOption: true,
          discountInput: {
            formType: "factor",
            name: "discount",
            label: "تخفیف",
            isPercentage: true,
          },
          taxOption: true,
          taxInput: {
            formType: "factor",
            name: "tax",
            label: "مالیات",
            isPercentage: true,
            defaultValue: 0,
          },
          transportOption: true,
          transportInput: {
            formType: "factor",
            name: "transport",
            label: "حمل و نقل",
            isPercentage: false,
          },
          returnOption: true,
          returnInput: {
            formType: "factor",
            name: "isReturnedFactor",
            label: "فاکتور مرجوعی",
          },
          customCostsInput: {
            formType: "factor",
            name: "additionalCosts",
          },
          draftOption: false,
          header: [
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
              active: true,
              type: "accountingCode",
              name: "accountingCode",
              label: "کد حسابداری",
              maxLength: 20,
              options: [
                {
                  label: "اتوماتیک",
                  value: true,
                },
                {
                  label: "دستی",
                  value: false,
                },
              ],
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "person",
                  title: "افزودن شخص",
                  closeButton: true,
                  onFinish: (token) => apiPersonsList(token, "provider"),
                },
              },
              name: "person",
              label: "تامین کننده",
              showInput: true,
              required: true,
              options: "providers",
              onChange: (dispatch, value) => {
                const title = value ? `فاکتور خرید ${value.nickName}` : null;
                dispatch(updateFactor("title", title));
              },
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              name: "title",
              label: "عنوان",
              maxLength: 64,
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              name: "reference",
              label: "ارجاع",
              maxLength: 64,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "datePickerInput",
              name: "storeDate",
              label: "تاریخ",
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "datePickerInput",
              name: "paymentDate",
              label: "تاریخ سررسید",
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "branch",
                  title: "افزودن شعبه",
                  closeButton: true,
                  onFinish: (token) => apiGetBranches(token),
                },
              },
              name: "branch",
              label: "شعبه",
              showInput: true,
              options: "branches",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "project",
                  title: "افزودن پروژه",
                  closeButton: true,
                  onFinish: (token) => apiGetProjects(token),
                },
              },
              name: "project",
              label: "پروژه",
              showInput: true,
              options: "projects",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "currency",
              name: "factor",
              label: "واحد پول",
              maxLength: 16,
              showInput: false,
            },
          ],
          body: [
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 style-fields-right',
            //     type: 'selectBox',
            //     name: 'productCategory',
            //     label: 'دسته بندی',
            //     showInput: true,
            //     options: 'productCategories'
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-3 col-md-3 col-sm-3 col-xs-6',
            //     type: 'selectBox',
            //     name: 'product',
            //     label: 'کالا / خدمات',
            //     showInput: true,
            //     options: 'products'
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-6",
            //     type: "empty"
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 ps-5',
            //     type: 'currency',
            //     name: 'factor',
            //     label: 'واحد پول',
            //     maxLength: 16,
            //     showInput: false,
            // },
            {
              formType: "factor",
              factorType: "buy",
              outerWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
              type: "factorTable",
              name: "items",
              inputs: [
                { key: "product", title: "محصول", size: "20", type: "select" },
                { key: "description", title: "شرح", size: "10", type: "text" },
                { key: "unit", title: "واحد", size: "10", type: "unit" },
                { key: "quantity", title: "تعداد", size: "10", type: "price" },
                { key: "price", title: "قیمت واحد", size: "10", type: "price" },
                {
                  key: "discount",
                  title: "تخفیف",
                  size: "10",
                  type: "discount",
                },
                { key: "tax", title: "مالیات", size: "10", type: "percent" },
                {
                  key: "totalPrice",
                  title: "قیمت کل",
                  size: "10",
                  type: "price",
                  disabled: true,
                },
              ],
            },
          ],
        },
      },
      {
        name: "ضایعات",
        key: "waste",
        form: {
          taxOption: false,
          transportOption: false,
          discountOption: false,
          returnOption: false,
          draftOption: false,
          customCostsInput: {
            formType: "factor",
            name: "additionalCosts",
          },
          header: [
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 px-1 style-padding-inputs",
              active: true,
              type: "accountingCode",
              name: "accountingCode",
              label: "کد حسابداری",
              maxLength: 20,
              options: [
                {
                  label: "اتوماتیک",
                  value: true,
                },
                {
                  label: "دستی",
                  value: false,
                },
              ],
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              name: "title",
              label: "عنوان",
              maxLength: 64,
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "datePickerInput",
              name: "storeDate",
              label: "تاریخ",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              name: "reference",
              label: "ارجاع",
              maxLength: 64,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "branch",
                  title: "افزودن شعبه",
                  closeButton: true,
                  onFinish: (token) => apiGetBranches(token),
                },
              },
              name: "branch",
              label: "شعبه",
              showInput: true,
              options: "branches",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "selectBox",
              addModal: {
                props: {
                  component: "project",
                  title: "افزودن پروژه",
                  closeButton: true,
                  onFinish: (token) => apiGetProjects(token),
                },
              },
              name: "project",
              label: "پروژه",
              showInput: true,
              options: "projects",
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
              name: "description",
              label: "توضیحات",
              required: true,
            },
            {
              formType: "factor",
              outerWrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-3 style-padding-inputs",
              type: "currency",
              name: "factor",
              label: "واحد پول",
              maxLength: 16,
              showInput: false,
            },
          ],
          body: [
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 style-fields-right',
            //     type: 'selectBox',
            //     name: 'productCategory',
            //     label: 'دسته بندی',
            //     showInput: true,
            //     options: 'productCategories'
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-3 col-md-3 col-sm-3 col-xs-6',
            //     type: 'selectBox',
            //     name: 'product',
            //     label: 'کالا / خدمات',
            //     showInput: true,
            //     options: 'products'
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-6",
            //     type: "empty"
            // },
            // {
            //     formType: "factor",
            //     outerWrapperClass: 'col-lg-2 col-md-2 col-sm-2 col-xs-6 ps-5',
            //     type: 'currency',
            //     name: 'product',
            //     label: 'واحد پول',
            //     maxLength: 16,
            //     showInput: false,
            // },
            {
              formType: "factor",
              factorType: "waste",
              outerWrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
              type: "factorTable",
              name: "items",
              inputs: [
                { key: "product", title: "محصول", size: "20", type: "select" },
                { key: "description", title: "شرح", size: "30", type: "text" },
                { key: "unit", title: "واحد", size: "10", type: "unit" },
                { key: "quantity", title: "تعداد", size: "10", type: "price" },
                { key: "price", title: "قیمت واحد", size: "10", type: "price" },
                {
                  key: "totalPrice",
                  title: "قیمت کل",
                  size: "10",
                  type: "price",
                  disabled: true,
                },
              ],
            },
          ],
        },
      },
    ],
  },
};
